var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs old"},[_c('li',{staticClass:"breadcrumbs__item old"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вкусно и быстро")])],1),_vm._l((_vm.linkArr),function(item){return _c('li',{staticClass:"breadcrumbs__item old"},[_c('a',{attrs:{"href":`/application${item.link}`}},[_vm._v(_vm._s(item.name))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }